import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HotelsQueryVariables = GraphQLTypes.Exact<{ [key: string]: never; }>;


export type HotelsQueryResult = (
  { __typename?: 'Query' }
  & { hotels?: GraphQLTypes.Maybe<Array<GraphQLTypes.Maybe<(
    { __typename?: 'Hotel' }
    & Pick<GraphQLTypes.Hotel, 'id' | 'name'>
  )>>> }
);


export const HotelsDocument = /*#__PURE__*/ gql`
    query hotels {
  hotels {
    id
    name
  }
}
    `;

/**
 * __useHotelsQuery__
 *
 * To run a query within a React component, call `useHotelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHotelsQuery(baseOptions?: Apollo.QueryHookOptions<HotelsQueryResult, HotelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HotelsQueryResult, HotelsQueryVariables>(HotelsDocument, options);
      }
export function useHotelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HotelsQueryResult, HotelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HotelsQueryResult, HotelsQueryVariables>(HotelsDocument, options);
        }
export type HotelsQueryHookResult = ReturnType<typeof useHotelsQuery>;
export type HotelsLazyQueryHookResult = ReturnType<typeof useHotelsLazyQuery>;